export default __webpack_public_path__ + "static/media/reassign-small.1e436c8d.svg";